<template>

<fragment>

    <input 
        type="text" 
        v-model="model" 
        :placeholder="placeholder[pickerType]" 
        :data-type="pickerType" 
        class="date-input" 
        v-on:focus="expanded = true" 
        v-propagation 
    />

	<com-datepicker 
        :data-type="pickerType" 
        :type="pickerType" 
        :clearable="false"
        :lang="lang"
        value-type="format"
        :format="format[pickerType]"
        :inline="true"
        :shortcuts="shortcuts"
        :show-week-number="false"
        :append-to-body="wrapper"
        v-on:focus="expanded = true"
        v-model="model" 
        v-on:pick="onDatePicked"
        class="date-panel"
        v-click-outside="onOutsideClick"
        v-if="expanded"
    />

</fragment>

</template>

<script>

import comDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

    props: ['value', 'type', 'wrapper', 'rule'],

	components: {
		'com-datepicker': comDatePicker
	},

    data: function() {

        return {
            model: '',
            expanded: false,
            lang: {
                formatLocale: {
                    firstDayOfWeek: 1
                }
            },
            placeholder: {
                day: 'DD/MM/YYYY',
                week: 'DD/MM/YYYY',
                month: 'MM/YYYY',
                year: 'YYYY'
            },
            format: {
                day: 'DD/MM/YYYY',
                week: 'DD/MM/YYYY',
                month: 'MM/YYYY',
                year: 'YYYY'
            }
        }

    },

    created: function() {

        this.model = this.value

    },

    watch: {

        pickerType: function() {

            this.model = ''
            this.expanded = false

        },

        value: function(n) {

            this.model = n

        },

        model: function(n) {

            this.$emit('input', n)

        }

    },

    computed: {

        pickerType: function() {

            return this.rule.setting.period

        },

        shortcuts: function() {

            var shortcuts = []

            if (this.pickerType === 'day') {

                shortcuts.push({
                    text: 'Today',
                    onClick: function() {

                        this.expanded = false

                        return new Date()

                    }.bind(this)
                })

                shortcuts.push({
                    text: 'Yesterday',
                    onClick: function() {

                        this.expanded = false

                        return new this.$moment().subtract(1, 'day').toDate()

                    }.bind(this)
                })

            } else if (this.pickerType === 'week') {

                shortcuts.push({
                    text: 'This Week',
                    onClick: function() {

                        this.expanded = false

                        return new Date()

                    }.bind(this)
                })

                shortcuts.push({
                    text: 'Last Week',
                    onClick: function() {

                        this.expanded = false

                        return new this.$moment().subtract(1, 'week').toDate()

                    }.bind(this)
                })

            } else if (this.pickerType === 'month') {

                shortcuts.push({
                    text: 'This Month',
                    onClick: function() {

                        this.expanded = false

                        return new Date()

                    }.bind(this)
                })

                shortcuts.push({
                    text: 'Last Month',
                    onClick: function() {

                        this.expanded = false

                        return new this.$moment().subtract(1, 'month').toDate()

                    }.bind(this)
                })

            } else if (this.pickerType === 'year') {

                shortcuts.push({
                    text: 'This Year',
                    onClick: function() {

                        this.expanded = false

                        return new Date()

                    }.bind(this)
                })

                shortcuts.push({
                    text: 'Last Year',
                    onClick: function() {

                        this.expanded = false

                        return new this.$moment().subtract(1, 'year').toDate()

                    }.bind(this)
                })

            }

            return shortcuts

        }

    },

    methods: {

        onDatePicked: function() {

            this.expanded = false

        },

        onOutsideClick: function() {

            this.expanded = false

        }

    }

}

</script>

<style scoped>

.date-input {
    background-color: #fff;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    height: 40px;
    width: 120px;
    font-weight: 400;
    text-align: center;
}

.is-mobile .date-input {
    border: 1px solid #eee;
}

.date-input[data-type="month"] {
    width: 84px;
}

.date-input[data-type="year"] {
    width: 54px;
}

.date-input::placeholder {
    color: #999;
}

.date-panel {
    position: absolute;
    top: 54px;
    width: 300px;
    border-radius: 10px;
    z-index: 1000;
}

.is-mobile .date-panel {
    border: 1px solid #eee;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.date-panel:after {
	content: ' ';
	position: absolute;
	top: -6px;
	left: 50%;
    margin-left: -6px;
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 6px 6px 6px;
	border-color: transparent transparent #fff transparent;
}

.is-mobile .date-panel:after {
    display: none;
}

.date-panel >>> .mx-calendar {
    width: 300px;
}

.date-panel >>> .mx-calendar-content .cell:not(.active):hover {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.05);
}

.date-panel >>> .mx-calendar-content .cell.active {
    border-radius: 4px;
    background-color: #4881bb;
    color: #fff;
}

.date-panel >>> .mx-calendar-week-mode .mx-date-row.mx-active-week .cell {
    background-color: #4881bb;
    overflow: hidden;
    color: #fff!important;
}

.date-panel >>> .mx-calendar-week-mode .mx-date-row.mx-active-week .cell:first-child {
    border-radius: 4px 0px 0px 4px;
}

.date-panel >>> .mx-calendar-week-mode .mx-date-row.mx-active-week .cell:last-child {
    border-radius: 0px 4px 4px 0px;
}

.date-panel >>> .mx-calendar-week-mode .mx-date-row.mx-active-week .cell.active {
    border-radius: 0px;
}

.date-panel >>> .mx-calendar-week-mode .mx-date-row.mx-active-week .cell.today {
    color: #fff!important;
}

.date-panel >>> .mx-datepicker-main {
    display: grid;
    grid-template-columns: 1fr;
}

.date-panel >>> .mx-datepicker-sidebar {
    float: none;
    width: auto;
    order: 2;
    border-top: 1px solid #ddd;
    grid-gap: 4px;
    display: grid;
    grid-template-columns: 1fr auto auto;
}

.date-panel >>> .mx-datepicker-sidebar:before {
    content: 'Shortcuts';
    font-size: 14px;
    color: #666;
}

.date-panel >>> .mx-datepicker-sidebar .mx-btn {
    background-color: #838c96;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
    margin: 0px;
}

.date-panel >>> .mx-datepicker-sidebar .mx-btn:hover {
    background-color: #6c747c;
}

.date-panel >>> .mx-datepicker-content {
    margin-left: 0px;
    border-left: 0px;
    order: 1;
}

.date-panel >>> .mx-datepicker-main {
    border-radius: 10px;
    border: 0px;
}

</style>